<template>
  <VModal class="payment-method-wrapper" :type="ModalType.custom">
    <!-- TODO check src/components/order/PaymentMethodModal.vue:20 -->
    <VBlock id="baemin-pay-layout">
      <VBlock id="baemin-pay-container" />
    </VBlock>
  </VModal>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VHR from '@/presentationals/v2/components/layouts/atoms/VHR'
import VStockButton, {
  StockButtonType
} from '@/presentationals/v2/components/layouts/atoms/VStockButton'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal, { ModalType } from '@/presentationals/v2/components/layouts/molecules/VModal'
import VA from '@/presentationals/v2/components/layouts/molecules/VA'

import BaeminPay from 'baeminpay-front'
import { StoreProps, PaymentMethodSelectionFlowProps } from '@/models/PreOrder/BaeminPaymentMethod'

export default {
  name: 'ModalPaymentMethod',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion
    }
  },
  components: {
    VA,
    VP,
    VButton,
    VSpan,
    VHR,
    VStockButton,

    VBlock,
    VModal
  },
  created() {
    const { appVersion } = this.$store.getters
    this.beforeNativeEvent = window.onClickNativeBack
    this.$store.commit('hideNavigationBar', { appVersion })
  },
  mounted() {
    this.targetElement = document.getElementById('baemin-pay-container')

    const baeminMemberNo = this.$store.getters.baeminMemberNo
    const storeProps = new StoreProps({
      memberNumber: baeminMemberNo,
      externals: {
        deeplink: process.env.VUE_APP_DEEP_LINK_PROTOCOL,
        action: process.env.VUE_APP_BAEMIN_ACTION_DEEP_LINK_PROTOCOL,
        INTERNAL_WEB: process.env.VUE_APP_BAEMIN_INTERNAL_WEB
      },
      logData: {
        env: process.env.NODE_ENV,
        sessionId: this.$store.getters.sessionId,
        dvcId: this.$store.getters.deviceId,
        screenName: 'Ord/Method'
      },
      setAndroidBackHandler: onClose => {
        window.onClickNativeBack = onClose
      }
    })

    const pocketNo = !this.params.paymentMethod.baeminpay
      ? null
      : this.params.paymentMethod.baeminpay.pocketNo

    const appVersionDeviceTypePrefix = this.$store.getters.isAndroid ? 'and1_' : 'iph1_'
    const paymentMethodProps = new PaymentMethodSelectionFlowProps({
      selectedCode: this.params.paymentMethod.code,
      paymentMethodList: this.params.paymentMethodOptions,
      selectedBaeminpayPocketNo: pocketNo,
      appVersion: appVersionDeviceTypePrefix + this.$store.getters.appVersion,
      guest: !this.$store.getters.isSign,
      onSelect: method => {
        this.params.onPaymentMethod({
          ...method,
          codeName: this.params.paymentMethodOptions.find(
            option => option.displayName === method.displayName
          ).codeName
        })
        this.onOK()
        const element = document.getElementById('baeminpay-modal-container')
        BaeminPay.ReactDomUnmount(element)
        element.remove()
        window.onClickNativeBack = this.beforeNativeEvent
      },
      onCancel: method => {
        this.onOK()
        const element = document.getElementById('baeminpay-modal-container')
        BaeminPay.ReactDomUnmount(element)
        element.remove()
        window.onClickNativeBack = this.beforeNativeEvent
      }
    })

    BaeminPay.renderPaymentMethodSelectionFlow('baemin-pay-container', {
      ...storeProps,
      ...paymentMethodProps
    })
  },
  destroyed() {
    const { appVersion } = this.$store.getters
    this.$store.commit('showNavigationBar', { appVersion })
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      StockButtonType,
      targetElement: null,

      modalElement: null,
      isOpenedModal: false,

      beforeNativeEvent: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-method-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;
  background-color: $background-white;
  display: block;

  .payment-header {
    padding: 10px 15px 10px 15px;
    align-items: center;
    box-sizing: border-box;

    .stock-wrapper {
      width: 24px;
      height: 24px;
    }

    .text {
      height: 22px;
      vertical-align: middle;
    }

    .blank {
      width: 30px;
    }
  }

  #baemin-pay-layout {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    margin: 0;
    padding: 0;
  }

  #baemin-pay-container {
    overflow: scroll;
  }
}
</style>


